export const convertBytesToMegaBytes = bytes =>
  Math.round((bytes / 1000000) * 100) / 100;
